import * as mobx from 'mobx';
import * as IoC from 'typescript-ioc';
import { SHORT_PLAIN_TEXT_150_LENGTH } from '../../../../../constants/common.constants';
import { EventExecutionRuntime } from '../../../../../domain/jobs/implementations/event-execution-runtime';

class CreateZoomMeetingsVM {
    @mobx.observable
    private isFormShown: boolean;
    @mobx.observable
    private selectedGroupId: number;
    @mobx.observable
    private topicText = '';
    @mobx.observable
    private formChecked: boolean;
    @mobx.observable
    public type: string;
    @mobx.observable
    private creatingZoomMeetings: boolean;


    constructor(
        public readonly generateRoomConnections: (groupId: number, additionalTopicText: string) => void,
        @IoC.Inject private readonly jobsPipeline: EventExecutionRuntime = IoC.Container.get(EventExecutionRuntime)
    ) {
        this.isFormShown = false;
        this.formChecked = false;
        this.type = '';
    }

    @mobx.action
    public showForm = () => {
        this.isFormShown = true;
    };

    @mobx.action
    public showConnectionsForm = () => {
        this.isFormShown = true;
        this.type = 'connections';
    };

    @mobx.action
    public hideForm = () => {
        this.isFormShown = false;
        this.cleanup();
    };

    public createZoomMeetingsHandle = () => {
        if (!this.checkForm()) {
            return;
        }
        if (this.type === 'connections') this.generateRoomConnections(this.getGroup(), this.getTopicText());

        this.hideForm();
    };

    public getIsFormShown = () => {
        return this.isFormShown;
    };

    public getGroup = () => {
        return this.selectedGroupId;
    };

    @mobx.action
    public setGroup = (groupId: number) => {
        this.selectedGroupId = groupId;
    };

    public getTopicText = () => {
        return this.topicText;
    };

    @mobx.action
    public setTopicText = (topicText: string) => {
        this.topicText = topicText;
    };

    public getTopicError() {
        return this.topicText.length > SHORT_PLAIN_TEXT_150_LENGTH ? `Maximum additional topic length is ${SHORT_PLAIN_TEXT_150_LENGTH} symbols` : null;
    }

    @mobx.action
    public checkForm(): boolean {
        this.formChecked = true;
        return !this.getTopicError();
    }

    public isFormChecked() {
        return this.formChecked;
    }

    @mobx.action
    public cleanup = () => {
        this.topicText = '';
        this.formChecked = false;
    };

    public composeCreateZoomMeetingsButtonProperties(): { disabled: boolean; text: string } {
        return {
            text: 'Create Zoom Meetings',
            disabled: !this.jobsPipeline.isReady()
        };
    }

    public composeGenerateRoomConnectionsButtonProperties(): { disabled: boolean; text: string } {
        return {
            text: 'Create Zoom Connections',
            disabled: !this.jobsPipeline.isReady()
        };
    }
}

export { CreateZoomMeetingsVM };
